/*
let addAnimation = function () {
 jQuery(".fade-up").each(function (index) {
   const text = new SplitType(jQuery(this), {
     types: "lines, words",
     lineClass: "word-line"
   });    
   let textInstance = jQuery(this);
   let line = textInstance.find(".word-line");
   let word = line.find(".word");    
   let tl = gsap.timeline({
     scrollTrigger: {
       trigger: textInstance,
       start: "top 85%",
       end: "top 85%",
       onComplete: function () {
         jQuery(textInstance).removeClass("fade-up");
       }
     }
   });    
   tl.set(textInstance, { opacity: 1 }).from(word, {
     y: "100%",
     skewX: "-6",
     duration: 2,
     stagger: 0.03,
     ease: "expo.out"
   });
 });
};

addAnimation();
window.addEventListener("resize", function (event) {
   if (jQuery(window).width() >= 992) {
	   addAnimation(); 
   }
});

// Wait for the DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with the class 'fade-up'
  const elements = document.querySelectorAll('.fade-up');

  // Loop through each element
  elements.forEach((element) => {
    // Create a timeline for the animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top 70%', // Adjust the trigger point as needed
      },
    });

    // Add the animations to the timeline
    tl.fromTo(
      element,
      { opacity: 0, y: 15 },
      { opacity: 1, y: 0, duration: 0.4 }
    );
  });
});

// Wait for the DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with the class 'fade-up'
  const elements = document.querySelectorAll('.fade-up-section');

  // Loop through each element
  elements.forEach((element) => {
    // Create a timeline for the animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top 70%', // Adjust the trigger point as needed
      },
    });

    // Add the animations to the timeline
    tl.fromTo(
      element,
      { opacity: 0, y: 15 },
      { opacity: 1, y: 0, duration: 0.2 }
    );
  });

});
*/
// Wait for the DOM to be ready
document.addEventListener('DOMContentLoaded', function () {

        // Wait for the DOM to be ready
    document.addEventListener('DOMContentLoaded', function () {
        // Get all elements with the class 'fade-up'
        const elements = document.querySelectorAll('.fade-up-section-slow');

        // Loop through each element
        elements.forEach((element) => {
            // Create a timeline for the animation
            const tl = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: 'top 70%', // Adjust the trigger point as needed
            },
            });

            // Add the animations to the timeline
            tl.fromTo(
            element,
            { opacity: 0, y: 35 },
            { opacity: 1, y: 0, duration: 0.9 }
            );
        });
    });
});
/*
// Wait for the DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with the class 'fade-up'
  const elements = document.querySelectorAll('.fade-up-subhead');

  // Loop through each element
  elements.forEach((element) => {
    // Create a timeline for the animation
    const t2 = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top 70%', // Adjust the trigger point as needed
      },
    });

    // Add the animations to the timeline
    t2.fromTo(
      element,
      { opacity: 0, y: 15 },
      { opacity: 1, y: 0, duration: 0.5 }
    );
  });
});
*/
// Wait for the DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with the class 'fade-up'
  const elements = document.querySelectorAll('.fade-up-content');

  // Loop through each element
  elements.forEach((element) => {
    // Create a timeline for the animation
    const t3 = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top 60%', // Adjust the trigger point as needed
      },
    });

    // Add the animations to the timeline
    t3.fromTo(
      element,
      { opacity: 0, y: 15 },
      { opacity: 1, y: 0, duration: 0.5 }
    );
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with the class 'fade-up-content-menu'
  const elements = document.querySelectorAll('.fade-up-content-menu');

  // Attach hover events to '.mega-menu'
  const megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach((menu) => {
    menu.addEventListener('mouseenter', function () {
      elements.forEach((element) => {
        // Animate on hover
        gsap.fromTo(
          element,
          { opacity: 0, y: 15 },
          { opacity: 1, y: 0, duration: 0.8 }
        );
      });
    });
  });
});
	
document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with the class 'fade-up'
  const elements = document.querySelectorAll('h1.banner-title');

  // Loop through each element
  elements.forEach((element) => {
    // Create a timeline for the animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top 70%', // Adjust the trigger point as needed
      },
    });

    // Add the animations to the timeline
    tl.fromTo(
      element,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.3 }
    );
  });
});

/*
$(document).ready(function () {
    const images = $('.fade-image');

    gsap.to(images, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: {
            amount: 0.2, // Total duration of the stagger effect
            from: "start", // Start the stagger from the first image
        },
        scrollTrigger: {
            trigger: $('.image-group'), // Trigger the animation on this container
            start: "top bottom", // Start when the top of the container hits the bottom of the viewport
            end: "top 50%", // End when the top of the container reaches the top of the viewport
            toggleActions: "play none none reverse", // Play on enter, reverse on leave
            scrub: true,
            once: false // Only animate once
        }
    });
    if ($(window).width() >= 1024) {
        gsap.set('.parent', { perspective: 400, autoAlpha: 1})

        var tl = gsap.timeline({
        scrollTrigger: {
            trigger:'.parent',
            pin:true,
            scrub:true
        }
        })
        .to('.box1', { x: -170, y: 20, rotation: -10, opacity: 1 })
        .to('.box2', { x: 300, y: -20, rotation: 15, opacity: 1 })
        .to('.box3', { x: 30, y: 280, rotation: 10, opacity: 1 });
    }


    

        //document.getElementById('partnership-section').classList.add('fade-up-section-slow');
        const elements = document.querySelectorAll('.img-zoom-fast');

        // Loop through each element
        elements.forEach((element) => {
            // Create a timeline for the animation
            const tl = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: 'top 70%', // Adjust the trigger point as needed
            },
            });

            // Add the animations to the timeline
            tl.fromTo(
            element,
            { opacity: 0, y: 35 },
            { opacity: 1, y: 0, duration: 0.9 }
            );
        });


        gsap.fromTo(".img-zoom",
            { scale: 0, opacity: 0 }, 
            { 
                scale: 1, 
                opacity: 1, 
                duration: 0.2, // Reduce duration for a quicker animation
                delay: 0.02, // Optional delay before the animation starts
                scrollTrigger: {
                    trigger: ".img-zoom",
                    start: "top 80%", // Adjust when the animation starts
                    end: "top 30%", // Adjust when the animation ends
                    scrub: false, // Smoothly scrubs the animation with the scroll
                    markers: false, // Optional: Show markers for debugging
                }
            }
        );
        gsap.set(".img-zoom", { transformOrigin: "center" });
   


    ScrollTrigger.create({
        trigger: ".partnership-section",
        start: "top bottom", // Adjust as needed
        end: "top top",
        onEnter: () => {
            //document.getElementById('partnership-section').classList.add('fade-up-section-slow');
            const elements = document.querySelectorAll('.partnership-section');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 0, y: 35 },
                { opacity: 1, y: 0, duration: 0.9 }
                );
            });
        },
        onLeaveBack: () => {
            //document.getElementById('partnership-section').classList.add('fade-up-section-slow');
            const elements = document.querySelectorAll('.partnership-section');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 1, y: 35 },
                { opacity: 0, y: 0, duration: 0.9 }
                );
            });
        }
    });

    ScrollTrigger.create({
      trigger: ".get-in-touch-section",
      start: "top bottom", // Adjust as needed
      end: "top top",
      onEnter: () => {      
          const elements = document.querySelectorAll('.get-in-touch-section');

          // Loop through each element
          elements.forEach((element) => {
              // Create a timeline for the animation
              const tl = gsap.timeline({
              scrollTrigger: {
                  trigger: element,
                  start: 'top 70%', // Adjust the trigger point as needed
              },
              });

              // Add the animations to the timeline
              tl.fromTo(
              element,
              { opacity: 0, y: 35 },
              { opacity: 1, y: 0, duration: 0.9 }
              );
          });
      },
      onLeaveBack: () => {          
          const elements = document.querySelectorAll('.get-in-touch-section');

          // Loop through each element
          elements.forEach((element) => {
              // Create a timeline for the animation
              const tl = gsap.timeline({
              scrollTrigger: {
                  trigger: element,
                  start: 'top 70%', // Adjust the trigger point as needed
              },
              });

              // Add the animations to the timeline
              tl.fromTo(
              element,
              { opacity: 1, y: 35 },
              { opacity: 0, y: 0, duration: 0.9 }
              );
          });
      }
  });


  if ($(window).width() <= 767) { 
   
    ScrollTrigger.create({
        trigger: ".top_gird_right",
        start: "top bottom", // Adjust as needed
        end: "top top",
        onEnter: () => {      
            const elements = document.querySelectorAll('.top_gird_right');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 0, y: 35 },
                { opacity: 1, y: 0, duration: 0.9 }
                );
            });
        },
        onLeaveBack: () => {          
            const elements = document.querySelectorAll('.top_gird_right');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 1, y: 35 },
                { opacity: 0, y: 0, duration: 0.9 }
                );
            });
        }
    });


    ScrollTrigger.create({
        trigger: ".bottom_right_gird.lightgreen-bg",
        start: "top bottom", // Adjust as needed
        end: "top top",
        onEnter: () => {      
            const elements = document.querySelectorAll('.bottom_right_gird.lightgreen-bg');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 0, y: 35 },
                { opacity: 1, y: 0, duration: 0.9 }
                );
            });
        },
        onLeaveBack: () => {          
            const elements = document.querySelectorAll('.bottom_right_gird.lightgreen-bg');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 1, y: 35 },
                { opacity: 0, y: 0, duration: 0.9 }
                );
            });
        }
    });


    ScrollTrigger.create({
        trigger: ".bottom_grid.visible-mob",
        start: "top bottom", // Adjust as needed
        end: "top top",
        onEnter: () => {      
            const elements = document.querySelectorAll('.bottom_grid.visible-mob');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 0, y: 35 },
                { opacity: 1, y: 0, duration: 0.9 }
                );
            });
        },
        onLeaveBack: () => {          
            const elements = document.querySelectorAll('.bottom_grid.visible-mob');

            // Loop through each element
            elements.forEach((element) => {
                // Create a timeline for the animation
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top 70%', // Adjust the trigger point as needed
                },
                });

                // Add the animations to the timeline
                tl.fromTo(
                element,
                { opacity: 1, y: 35 },
                { opacity: 0, y: 0, duration: 0.9 }
                );
            });
        }
    });
  }  
});
*/